import {BaseDTO} from '../../common/models/BaseDTO';
import {IssueTicketAttachmentsDTO} from './IssueTicketAttachmentsDTO';

export class IssueTicketAttachmentsLinkDTO extends BaseDTO {
  issueTicketAttachment: IssueTicketAttachmentsDTO;
}
